import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "TextVerticalAlignment"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M22.5 21H12V22.5H22.5V21zM22.5 17.25H12V18.75H22.5V17.25zM8.13435 22.5H9.75L6.48 15H4.77L1.5 22.5H3.11565L3.71565 21H7.53435L8.13435 22.5zM4.31557 19.5 5.625 16.226 6.93443 19.5H4.31557zM22.5 11.25H1.5V12.75H22.5V11.25zM22.5 5.25H12V6.75H22.5V5.25zM22.5 1.5H12V3H22.5V1.5zM8.13435 9H9.75L6.48 1.5H4.77L1.5 9H3.11565L3.71565 7.5H7.53435L8.13435 9zM4.31557 6 5.625 2.72603 6.93443 6H4.31557z" }, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/TextVerticalAlignment.vue"]]);
